import { Box } from '@mui/material';
import { DataGrid } from "@mui/x-data-grid";
import React from 'react';

const TableComponent = ({rows, columns,}) => {
  return (
    <Box
    sx={{
      flexGrow: 1,
      maxWidth: { xs: 650, sm: 782, lg: 1350 },
      bgcolor: "background.paper",
    }}
  >
    <DataGrid
      rows={rows}
      columns={columns}
      disableSelectionOnClick
      pageSizeOptions={[25, 50, 100]}
      initialState={{
        pagination: {
          paginationModel: {
            pageSize: 25,
          },
        },
      }}
    />
  </Box>
  )
}

export default TableComponent;